import React from "react";
import MejorateQuiz from "./MejorateQuiz";

const preguntasCannabis = [
  // Pregunta 1
  {
    question: "¿Cuál es una posible consecuencia del uso crónico de cannabis?",
    options: [
      "Incremento en la memoria a largo plazo",
      "Dependencia física y psicológica",
      "Mayor resistencia a otras sustancias adictivas",
      "Disminución del riesgo de dependencia",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 2
  {
    question: "¿Por qué el cannabis puede ser adictivo?",
    options: [
      "Porque disminuye la sensibilidad del sistema inmunológico",
      "Porque ralentiza los procesos metabólicos del cuerpo",
      "Porque afecta al sistema de recompensa del cerebro, aumentando los niveles de dopamina",
      "Porque aumenta la producción de glóbulos rojos en la sangre",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 3
  {
    question:
      "¿Qué conjunto de síntomas puede indicar un síndrome de abstinencia por consumo crónico de cannabis?",
    options: [
      "Aumento del apetito, calma mental y bienestar físico",
      "Aumento de energía y mejor descanso",
      "Irritabilidad, alteraciones del sueño y malestar físico",
      "Motivación elevada y reducción de la inquietud",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 4
  {
    question:
      "¿Cuáles de los siguientes síntomas pueden presentarse en el síndrome de abstinencia por consumo crónico de cannabis?",
    options: [
      "Mejora en la calidad del sueño",
      "Irritabilidad e inquietud",
      "Aumento en la concentración",
      "Reducción de la ansiedad",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 5
  {
    question:
      "¿Qué efectos cognitivos puede causar el uso prolongado de cannabis?",
    options: [
      "Mejora de la memoria y mayor rapidez mental",
      "Problemas de memoria, atención y toma de decisiones",
      "Aumento en la capacidad de concentración y organización",
      "Incremento en la creatividad y resolución de problemas",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 6
  {
    question:
      "¿Cuáles de los siguientes síntomas psicológicos pueden ser provocados por el consumo prolongado de cannabis?",
    options: [
      "Motivación elevada y sensación de bienestar constante",
      "Paranoia, alucinaciones y ansiedad",
      "Reducción del estrés y estabilidad emocional",
      "Mejora en el estado de ánimo y relajación",
    ],
    correctAnswerIndex: 1,
  },
  //Pregunta 7
  {
    question:
      "¿Qué alteraciones emocionales puede provocar el consumo prolongado de cannabis?",
    options: [
      "Motivación elevada y calma",
      "Irritabilidad y alteraciones del estado de ánimo",
      "Mejora de la estabilidad emocional y reducción del estrés",
      "Mayor paciencia y tolerancia",
    ],
    correctAnswerIndex: 1,
  },
  //Pregunta 8
  {
    question:
      "¿Qué trastornos psicológicos puede padecer un consumidor crónico de cannabis?",
    options: [
      "Síndrome de Tourette",
      "Agorafobia y mutismo selectivo",
      "Depresión y ansiedad",
      "Trastorno de personalidad narcisista y déficit de atención",
    ],
    correctAnswerIndex: 2,
  },
  //Pregunta 9
  {
    question:
      "¿Qué efecto puede inducir el consumo excesivo o crónico de cannabis, especialmente en personas con predisposición genética?",
    options: [
      "Aumento en la motivación y la concentración",
      "Mejora en la estabilidad emocional y la memoria",
      "Trastornos psicóticos",
      "Incremento en la tolerancia al estrés y la resolución de problemas",
    ],
    correctAnswerIndex: 2,
  },
  //Pregunta 10
  {
    question:
      "¿Qué similitudes o diferencias existen respecto al humo del tabaco?",
    options: [
      "El humo del cannabis contiene vitaminas y antioxidantes beneficiosos para los pulmones",
      "El humo del cannabis contiene toxinas y carcinógenos similares a los del tabaco",
      "El humo del cannabis tiene un efecto protector sobre los pulmones y reduce la inflamación",
      "El humo del cannabis es más limpio y menos perjudicial que el del tabaco",
    ],
    correctAnswerIndex: 1,
  },
  //Pregunta 11
  {
    question: "¿Cómo afecta el humo del cannabis a los pulmones a largo plazo?",
    options: [
      "Mejora la oxigenación de los tejidos y la función pulmonar",
      "Aumenta el riesgo de bronquitis crónica y daño pulmonar",
      "Reduce la probabilidad de enfermedades respiratorias",
      "Incrementa la capacidad de filtración de aire en los pulmones",
    ],
    correctAnswerIndex: 1,
  },
  //Pregunta 12
  {
    question:
      "¿Qué efecto produce el consumo de cannabis en relación con la conducción?",
    options: [
      "Mayor agudeza visual y mejor tiempo de reacción",
      "Mayor riesgo de accidentes de tráfico",
      "Reducción del cansancio y aumento de la concentración en la carretera",
      "Mejora en la capacidad de conducir en condiciones adversas",
    ],
    correctAnswerIndex: 1,
  },
  //Pregunta 13
  {
    question: "¿Qué papel juega el consumo de cannabis a la hora de conducir?",
    options: [
      "Mejora la capacidad de reacción y coordinación motora",
      "Afecta la coordinación motora, la percepción del tiempo y la distancia, y, por tanto, a la capacidad de reacción",
      "Disminuye la posibilidad de accidentes al aumentar la atención",
      "Incrementa la rapidez en la toma de decisiones al conducir",
    ],
    correctAnswerIndex: 1,
  },
  //Pregunta 14
  {
    question:
      "¿Cuál es una de las consecuencias del uso prolongado de cannabis en el entorno laboral?",
    options: [
      "Mejora en el rendimiento laboral",
      "Deterioro en el rendimiento y relaciones laborales",
      "Aumento de la eficiencia",
      "Mejor enfoque en tareas",
    ],
    correctAnswerIndex: 1,
  },
  //Pregunta 15
  {
    question:
      "¿Cuál es un posible efecto del uso prolongado de cannabis en el ámbito laboral?",
    options: [
      "Pérdida de productividad debido a problemas de atención y memoria",
      "Aumento de la proactividad en el trabajo",
      "Mejor adaptación a tareas de alta presión",
      "Incremento en la resistencia al estrés",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 16
  {
    question:
      "¿Qué factores aumentan significativamente el riesgo de efectos adversos al consumir cannabis?",
    options: [
      "La frecuencia de ejercicio físico y la dieta",
      "La ocupación y el nivel educativo",
      "El contenido de THC, el nivel y la duración del consumo ",
      "La cantidad de horas de sueño y la exposición al sol",
    ],
    correctAnswerIndex: 2,
  },
];

export default function MejorateCannabis() {
  return <MejorateQuiz quizType="Cannabis" questions={preguntasCannabis} />;
}
